import React from 'react';
import {
  IconAirplane, IconCar, IconCruiseShip, IconHome, IconHotel, IconTravelBag,
} from '@americanexpress/dls-icons';

export const FLIGHTS_TAB = 'flights';
export const HOTELS_TAB = 'hotels';
export const VACATION_RENTALS_TAB = 'vacation-rentals';
export const GUESTBOOK_TAB = 'guestbook';
export const PACKAGES_TAB = 'packages';
export const CARS_TAB = 'cars';
export const CRUISES_TAB = 'cruises';

export const TAB_TO_MODULE_NAME = {
  [HOTELS_TAB]: 'axp-travel-search-hotels',
  [CARS_TAB]: 'axp-travel-search-cars',
  [FLIGHTS_TAB]: 'axp-travel-search-flights',
  [CRUISES_TAB]: 'axp-travel-search-cruises',
  [PACKAGES_TAB]: 'axp-travel-search-flight-hotel',
  [VACATION_RENTALS_TAB]: 'travel-vacation-rentals-search',
  [GUESTBOOK_TAB]: 'travel-guestbook-search',
};

export const TAB_TO_ELEMENT = {
  [VACATION_RENTALS_TAB]: 'confirm vacation rental',
};

export const TAB_TO_ICON = (selected, styles) => ({
  [HOTELS_TAB]: <IconHotel isFilled={selected} size="md" className={styles} />,
  [CARS_TAB]: <IconCar isFilled={selected} size="md" className={styles} />,
  [FLIGHTS_TAB]: <IconAirplane isFilled={selected} size="md" className={styles} />,
  [CRUISES_TAB]: <IconCruiseShip isFilled={selected} size="md" className={styles} />,
  [PACKAGES_TAB]: <IconTravelBag isFilled={selected} size="md" className={styles} />,
  [VACATION_RENTALS_TAB]: <IconHome isFilled={selected} size="md" className={styles} />,
  [GUESTBOOK_TAB]: <IconHome isFilled={selected} size="md" className={styles} />,
});
